/**
 * Performance Alerts API client.
 *
 * Backend is still under construction. To unblock UI design and review, the
 * saga falls back to localStorage if these endpoints aren't reachable yet.
 * Once the backend ships `/performance-alerts`, no UI/redux code changes —
 * the saga's network path will start succeeding and the fallback path will
 * stop running.
 */
import { request } from "../helpers/axios.new";

const BASE = "/performance-alerts";

export const GET_ALERTS = () => request({ url: BASE, method: "GET" });

export const CREATE_ALERT = (data) =>
  request({ url: BASE, method: "POST", data });

export const UPDATE_ALERT = (id, data) =>
  request({ url: `${BASE}/${id}`, method: "PUT", data });

export const DELETE_ALERT = (id) =>
  request({ url: `${BASE}/${id}`, method: "DELETE" });

export const TOGGLE_ALERT = (id, enabled) =>
  request({
    url: `${BASE}/${id}/toggle`,
    method: "PATCH",
    data: { enabled },
  });
